import { Stack } from 'react-bootstrap';
import { Redirect, Route, RouteProps } from 'react-router-dom';

import { Location } from 'history';

import Header from './components/custom_components/Header/Header';
import Sidebar from './components/Sidebar';
import { UserRoleEnum } from './models/GalenData/UserRole.model';
import { UserPermission } from './models/Settings.model';
import useRemoteBoundStore from './store/useRemoteBoundStore';
import { getFirstAvailablePage, getSessionPage } from './utils/navigatePages';

const getRedirectPath = (
  location: Location,
  authToken: string,
  userType: UserRoleEnum | undefined,
  userPermission: UserPermission,
) => {
  if (!authToken) {
    return { pathname: '/login' };
  }

  if (getSessionPage(null, location) && !userPermission.create) {
    return { pathname: getFirstAvailablePage(userPermission) };
  }

  if (location.pathname === '/results' && !userPermission.list) {
    return { pathname: getFirstAvailablePage(userPermission) };
  }

  if (
    userType === UserRoleEnum.PracticeUser &&
    location.pathname === '/subuser'
  ) {
    return { pathname: getFirstAvailablePage(userPermission) };
  }
  return null;
};

function PrivateRoute({
  children,
  ...rest
}: { children: React.ReactNode } & RouteProps) {
  const {
    authInfo: { authToken },
    currentUser,
    userSettings: { userPermission },
  } = useRemoteBoundStore();

  const userType = currentUser?.currentRole?.role;

  return (
    <Route
      {...rest}
      render={({ location }) => {
        const redirectPath = getRedirectPath(
          location,
          authToken,
          userType,
          userPermission,
        );
        if (redirectPath) {
          return <Redirect to={redirectPath} />;
        }
        return (
          <Stack className="px-5 py-4 vh-100 d-flex flex-column" gap={4}>
            <Header />

            <div className="flex-grow-1 border border-primary rounded-5 overflow-hidden">
              <div className="h-100 d-flex">
                <div className="d-none d-md-block flex-shrink-0">
                  <Sidebar />
                </div>
                <Stack className="flex-grow-1 p-4" style={{ minWidth: 0 }}>
                  {children}
                </Stack>
              </div>
            </div>
          </Stack>
        );
      }}
    />
  );
}

export { PrivateRoute };
